export default __webpack_public_path__ + "static/media/img-0803-greece-premium-face.24c41033.png";